import axios from "axios";
import { useState } from "react";
import { object, string } from "yup";
import * as yup from "yup";
import { contatoValidation, enderecoValidation, getFields, informacoesGeraisValidation } from "~services/utils/defaultValidations";

const useReceiver = (id = 0, validateContato = true) => {
  const [valuess, setValue] = useState({ name: "", value: "" });
  const location = window.location.pathname;
  const isRecebecorRequired = /\/carteira\/recebedor\/\d+$/.test(window.location.pathname);

  let dataValidate = {
     recebimento: !validateContato
    ? yup
        .string()
        .nullable()
        .test(
          "is-required",
          "Forma de recebimento é obrigatória",
          (value) => {
            if (isRecebecorRequired) {
              return !!value;
            }
            return true;
          }
        )
    : yup.string().nullable(),
    contatos: !validateContato || validateContato  ? yup.array().of(yup.object({
      ...getFields(contatoValidation(), ['nome', 'sobrenome', 'cargoId', 'email', 'telefone'])
    })) : null,
   ...getFields(informacoesGeraisValidation(), ['trilhaId', 'classificacaoFiscal', 'recebimento','grupoSegmentoId','segmentoId', ,'grupoCentralizadorId', 'descargaCliente', 'descargaFumaca', 'equipeVendaId', 'escritorioVendaId']),
  };

  if (id == 0) {
    dataValidate = {
    ...getFields(informacoesGeraisValidation(), ['codigoSAP', 'codigoVendedor']),
    ...getFields(enderecoValidation(), ['cep','numero','complemento','uf','rua','bairro','cidadeId']),
      concorrente: yup
        .object()
        .shape({
          checkboxSim: yup.boolean(),
          checkboxNao: yup.boolean(),
        })
        .test("concorrente", null, (obj) => {
          const { checkboxSim, checkboxNao } = obj;

          if (!checkboxSim && !checkboxNao) {
            return new yup.ValidationError(
              "Selecione se é cliente concorrente",
              null,
              "concorrente"
            );
          }
        }),
      selectedOptions: yup
        .array()
        .when("concorrente.checkboxSim", ([concorrente], teste) => {
          return concorrente
            ? teste.min(1, "selecione 1 ou mais opções")
            : teste.min(0);
        }),

      ...dataValidate,
    };
  }

  const validationSchema = object(dataValidate);

  const [initialValues, setinitialValues] = useState({
    id: 0,
    idVendaMais: 0,
    codigoSAP: "",
    codigoProspect: "",
    codigoVendedor: "",
    cep: null,
    numero: null,
    complemento: "",
    uf: null,
    rua: null,
    bairro: null,
    cidadeId: null,
    enderecoBloqueado: false,
    contatos: [
      {
        id: 0,
        nome: "",
        sobrenome: "",
        cargoId: null,
        email: "",
        telefone: "",
        celular: ""
        // fonte: ""
      },
    ],
    trilhaId: null,
    classificacaoFiscal: null,
    grupoSegmentoId: null,
    segmentoId: null,
    grupoCentralizadorId: 0,
    descargaCliente: false,
    descargaFumaca: false,
    diasAntecipacao: 1,
    concorrente: {
      checkboxNao: true,
    },
    produtos: [],
    telefone: "",
    celular: "",
    email: "",
    recebimento: "",
    escritorioVendaId: "",
    equipeVendaId: "",
    grupoCentralizadorConstrutoraId: "",
    nomeObra: ""
  });

  const cpfCnpj = (newValue) => {
    if (newValue.length <= 14) {
      return [
        /\d/,
        /\d/,
        /\d/,
        ".",
        /\d/,
        /\d/,
        /\d/,
        ".",
        /\d/,
        /\d/,
        /\d/,
        "-",
        /\d/,
        /\d/,
      ];
    } else {
      return [
        /[A-Za-z0-9]/,
        /[A-Za-z0-9]/,
        ".",
        /[A-Za-z0-9]/,
        /[A-Za-z0-9]/,
        /[A-Za-z0-9]/,
        ".",
        /[A-Za-z0-9]/,
        /[A-Za-z0-9]/,
        /[A-Za-z0-9]/,
        "/",
        /[A-Za-z0-9]/,
        /[A-Za-z0-9]/,
        /[A-Za-z0-9]/,
        /[A-Za-z0-9]/,
        "-",
        /\d/,
        /\d/,
      ];
    }
  };


  return {
    validationSchema,
    initialValues,
    setinitialValues,
    cpfCnpj,
    setValue,
    valuess
  };
};

export default useReceiver;